import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { AdditionalService } from '@services/additional-service';
import { Organization } from '../organization';

export class PackageDeal extends BaseEntity {
	name: string;
	description?: string;
	summary?: string;
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	@Type(() => AdditionalService)
	services: AdditionalService[];

	available?: boolean;
	selected?: boolean;
	logoUrl?: string;
}
